import React, { useState, useEffect } from "react";
import * as Const from "./../_Const";
import useScreenType from "../hooks/useScreenType";

const path = "/img/anim/";
const images = ["0", "0", "0", "0", "0", "1", "2", "3", "4", "5", "6", "7"];

const IMAGE_DISPLAY_TIME = 500; // 250ms

const ImageCardAnimation = ({ docType = Const.DOC_TYPE_INSURANCE_CARD }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const screenType = useScreenType();

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, IMAGE_DISPLAY_TIME);

    return () => clearInterval(intervalId);
  }, []);

  let img = "karticka";
  switch (docType) {
    case Const.DOC_TYPE_DRIVER_LICENCE:
      img = "dl";
      break;
    case Const.DOC_TYPE_ID:
      img = "op";
      break;
  }

  function getCssFor(what) {
    let css = "";
    if (screenType === Const.SCREEN_RPIV1) {
      switch (what) {
        case "image":
          css = "top-4 left-[28px] w-36";
          break;
        case "frame":
          css = "w-[200px]";
          break;
        case "frame-parent":
          css = "w-[200px] h-64";
          break;
      }
    } else if (screenType === Const.SCREEN_RPIV2) {
      switch (what) {
        case "image":
          css = "top-5 left-8 w-60";
          break;
        case "frame":
          css = "w-[300px]";
          break;
        case "frame-parent":
          css = "w-[300px] h-64";
          break;
      }
    } else if (screenType === Const.SCREEN_WAVESHARE) {
      switch (what) {
        case "image":
          css = "top-5 left-8 w-60";
          break;
        case "frame":
          css = "w-[300px]";
          break;
        case "frame-parent":
          css = "w-[300px] h-64";
          break;
      }
    }
    //console.log(what, screenType, css);

    return css;
  }

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  return (
    <div className="flex bg-accenta place-content-center items-center">
      <div className={`${getCssFor("frame-parent")} flex items-start justify-start relative `}>
        <img src="/img/anim/ramecek.png" className={`${getCssFor("frame")} absolute top-0 object-contain  z-0`} />

        {images.map((src, index) => (
          <img
            key={index} // Klíč pro React, důležité pro mapování seznamů
            src={`${path}${img}_${src}.png`}
            alt={`Obrázek ${index}`}
            // Dynamické nastavení opacity na základě currentIndex
            className={`
              absolute      
              ${getCssFor("image")}  object-contain z-10
              ${index === currentIndex ? "opacity-100" : "opacity-0"}              
            `}
          />
        ))}
      </div>
    </div>
  );
};

export default ImageCardAnimation;
